import { render, staticRenderFns } from "./social-cards.vue?vue&type=template&id=1176905e&scoped=true&"
import script from "./social-cards.vue?vue&type=script&lang=js&"
export * from "./social-cards.vue?vue&type=script&lang=js&"
import style0 from "./social-cards.vue?vue&type=style&index=0&id=1176905e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176905e",
  null
  
)

export default component.exports